import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export type BreadcrumbItem = {
  content: string;
  link?: string;
  onClick?: () => void;
  key?: string;
};

type PassedProps = {
  items: BreadcrumbItem[];
};

export default function Breadcrumbs({ items }: PassedProps) {
  const divider = '/';
  return (
    <ul
      data-testid="breadcrumbs"
      data-qa-testid="breadcrumbs"
      className="flex gap-0.5 text-sm text-black-055"
    >
      {items.map((item, index) => (
        <Fragment key={item.key || item.content}>
          <li>
            {item.link ? (
              <Link className="text-text-link" to={item.link} onClick={item.onClick}>
                {item.content}
              </Link>
            ) : (
              <span>{item.content}</span>
            )}
          </li>
          {index !== items.length - 1 && <li className="text-black-020">{divider}</li>}
        </Fragment>
      ))}
    </ul>
  );
}
